module.exports = __webpack_public_path__ + "static/media/BB10s.701d8eb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/desktop/BB10s.svg
// module id = 109
// module chunks = 0